// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { startOfDay as fn } from "../startOfDay.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const startOfDay = convertToFP(fn, 1);

// Fallback for modularized imports:
export default startOfDay;
